import { AnimatePresence, motion } from "framer-motion";
import React, { forwardRef, useState } from "react";

import { PaginationNumbers } from "../../pagination/pagination-numbers";
import {
  CustomerStoriesGridItem,
  CustomerStoriesGridItemProps,
} from "./customer-stories-grid-item";

export interface CustomerStoriesGridProps {
  stories: Omit<CustomerStoriesGridItemProps, "labels">[];
  labels: Record<string, string | null>;
}

export const CustomerStoriesGrid = forwardRef<HTMLDivElement, CustomerStoriesGridProps>(
  ({ stories, labels }, ref) => {
    const pageSize = 6;
    const [pageIndex, setPageIndex] = useState(0);
    return (
      <div className="flex flex-col gap-10 lg:gap-20" ref={ref}>
        <AnimatePresence initial={false} mode="popLayout">
          {stories.length && (
            <motion.div
              className="h-full flex w-full flex-col justify-stretch"
              key={pageIndex}
              initial={{
                opacity: 0,
              }}
              animate={{
                opacity: 1,
              }}
              exit={{
                opacity: 0,
              }}
              transition={{
                opacity: { ease: "easeOut", duration: 0.5 },
              }}
            >
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-6 gap-y-6 lg:gap-y-20">
                {stories.slice(pageIndex * pageSize, (pageIndex + 1) * pageSize).map((story, i) => {
                  return <CustomerStoriesGridItem key={String(i)} {...story} labels={labels} />;
                })}
              </div>
            </motion.div>
          )}
          {!stories.length && (
            <div className="container mx-auto h-64 flex items-center justify-center">
              <p>{labels["customer-grid-empty-state"]}</p>
            </div>
          )}
        </AnimatePresence>
        <PaginationNumbers
          totalPages={Math.ceil(stories.length / pageSize)}
          currentPageIndex={pageIndex}
          setCurrentPageIndex={(i) => {
            setPageIndex(i);
          }}
          visibleItemsCount={3}
        />
      </div>
    );
  }
);
